




import { Component, Vue, Prop } from "vue-property-decorator";
import SelectOption from "@/common/ui/presenters/select-option";

@Component({})
export default class SelectFavorite extends Vue {
  @Prop({ required: true }) value!: string;

  options: SelectOption[] = [
    { text: "お気に入りのみ", value: "1" },
    { text: "全て", value: "" }
  ];

  input(value: string) {
    return this.$emit("input", value);
  }
}
